/**
 * How the router scrolls a page it shows. From lg each page scrolls its own body, and every page's
 * body sits at the same place in the document, so the router took the next page's body for the
 * same element and carried the offset over: a register opened part-way down after a form, or at
 * its bottom (ALS-438). Named here, a page reached by a link or a save opens at its top; Back still
 * returns to where the reader was, and a filter or tab change, which passes resetScroll: false,
 * still stays put.
 */
export const ROUTER_SCROLL = {
    scrollRestoration: true,
    scrollToTopSelectors: ['[data-slot="page-body"]'],
};

/**
 * The nearest ancestor that scrolls vertically, or the document when none does. From lg that is
 * usually the app shell's page body; below lg the document scrolls, so it is the document.
 */
export function scrollingAncestor(element: Element): Element {
    for (let node = element.parentElement; node; node = node.parentElement) {
        const { overflowY } = getComputedStyle(node);
        if (
            (overflowY === 'auto' || overflowY === 'scroll') &&
            node.scrollHeight > node.clientHeight
        ) {
            return node;
        }
    }
    return document.scrollingElement ?? document.documentElement;
}

/**
 * Where the visible part of `scroller` begins, in viewport pixels: its top edge, or the
 * viewport's for the document, plus its scroll padding, which is how a phone's sticky top bar
 * keeps what it covers from counting as seen.
 */
export function visibleTop(scroller: Element): number {
    const page = document.scrollingElement ?? document.documentElement;
    const edge = scroller === page ? 0 : scroller.getBoundingClientRect().top;
    return edge + (parseFloat(getComputedStyle(scroller).scrollPaddingTop) || 0);
}
